module.exports = __webpack_public_path__ + "img/能量榜.93c25bc5.png";